import { isLoggedOutError, startLogin } from "@auth/login"
import { meQuery } from "@auth/me.query"
import type { QueryClient } from "@tanstack/react-query"
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"
import type { FC } from "react"

import { ErrorState } from "./-RootError"

export type RouterContext = {
  queryClient: QueryClient
}

const RootLayout: FC = () => (
  <>
    <Outlet />
    <TanStackRouterDevtools position="bottom-right" />
  </>
)
export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: async ({ context }) => {
    try {
      await context.queryClient.query(meQuery)
    } catch (error) {
      if (isLoggedOutError(error)) {
        await startLogin()
      }

      throw new Error("Could not get Me", { cause: error })
    }
  },
  component: RootLayout,
  errorComponent: ErrorState,
})
